import { CommentsActions, ECommentsActions } from '../actions/comment.actions';
import { CommentsState, initialCommentsState } from '../states/comments.state';

export function commentsReducers(
    state = initialCommentsState,
    action: CommentsActions
): CommentsState {
    switch (action.type) {
        case ECommentsActions.GetCommentsSuccess: {
            return {
                ...state,
                comments: action.payload
            };
        }

        case ECommentsActions.GetCommentsFailure: {
            return {
                ...state,
                comments: []
            };
        }

        default:
            return state;
    }
}
